
import axios from 'axios'

const request = axios.create({
  baseURL: process.env.VUE_APP_ANALYTICS_URL,
  timeout: 5000
})

export default {
  push (event) {
    request.post('/streamdata', event)
  }
}
